// stores/useAuthStore.ts
import { defineStore } from 'pinia'
import { ref, computed } from 'vue'
import type { LoginCredentials, TokenResponse, AuthUser } from '@/types/auth'
import authAPI from '@/api/authAPI'

export const useAuthStore = defineStore('auth', () => {
  const accessToken = ref<string>(localStorage.getItem('accessToken') || '')
  const refreshToken = ref<string>(localStorage.getItem('refreshToken') || '')
  const user = ref<AuthUser | null>(
    JSON.parse(localStorage.getItem('authUser') || 'null')
  )

  const isAuthenticated = computed<boolean>(() => {
    console.log('🔐 Checking auth - Token exists:', !!accessToken.value)
    console.log('🔐 Token length:', accessToken.value.length)
    return !!accessToken.value
  })

  const login = async (credentials: LoginCredentials): Promise<TokenResponse> => {
    console.log('🔐 Starting login process...')
    
    const response: TokenResponse = await authAPI.login(credentials)
    
    console.log('🔐 Login successful, tokens received:')
    console.log('🔐 Access token length:', response.access.length)
    console.log('🔐 Refresh token length:', response.refresh.length)
    
    accessToken.value = response.access
    refreshToken.value = response.refresh
    user.value = {
      username: credentials.username
    }
    
    localStorage.setItem('accessToken', response.access)
    localStorage.setItem('refreshToken', response.refresh)
    localStorage.setItem('authUser', JSON.stringify(user.value))
    
    console.log('🔐 Tokens saved to localStorage')
    
    return response
  }

  const refreshAuth = async (): Promise<boolean> => {
    console.log('🔄 Attempting token refresh...')
    try {
      const response: TokenResponse = await authAPI.refreshToken(refreshToken.value)
      accessToken.value = response.access
      localStorage.setItem('accessToken', response.access)
      console.log('🔄 Token refresh successful')
      return true
    } catch (error) {
      console.error('🔄 Token refresh failed:', error)
      logout()
      return false
    }
  }

  const logout = (): void => {
    console.log('🚪 Logging out...')
    accessToken.value = ''
    refreshToken.value = ''
    user.value = null
    
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('authUser')
    
    console.log('🚪 Logout complete')
  }

  // Método para debug
  const debugAuth = (): void => {
    console.log('=== AUTH DEBUG ===')
    console.log('Access Token:', accessToken.value ? `Present (${accessToken.value.length} chars)` : 'Missing')
    console.log('Refresh Token:', refreshToken.value ? `Present (${refreshToken.value.length} chars)` : 'Missing')
    console.log('User:', user.value)
    console.log('isAuthenticated:', isAuthenticated.value)
    console.log('==================')
  }

  return {
    accessToken,
    refreshToken,
    user,
    isAuthenticated,
    login,
    refreshAuth,
    logout,
    debugAuth
  }
})